<div class="w-full flex flex-col gap-6 text-lg">
  <p id="text-description" class="w-full text-center">
    @if (isSubmitSuccess()) {
      <span class="success-text">{{ "passwordReset.successMessage.updateSuccess" | translate }}</span>
    } @else {
      <span class="error-text">{{ "passwordReset.errorMessage.expiredSession" | translate }}</span>
    }
  </p>

  <div class="w-full">
    @if (isSubmitSuccess()) {
      <syn-button
        variant="filled"
        type="button"
        id="backLoginButton"
        class="w-full"
        style="width: 100%"
        (click)="redirectToLogin()"
      >
        <syn-icon slot="prefix" name="login" aria-hidden="true"></syn-icon>
        {{ 'login.login' | translate }}
      </syn-button>
    }

    @if (!isSubmitSuccess()) {
      <syn-button
        variant="outline"
        type="button"
        id="backPasswordForgotButton"
        class="w-full"
        style="width: 100%"
        (click)="redirectToPasswordForgot()"
      >
        <syn-icon slot="prefix" name="arrow_back" aria-hidden="true"></syn-icon>
        {{ 'passwordReset.backToPasswordForgot' | translate }}
      </syn-button>
    }
  </div>
</div>
